"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var Skeleton_1 = require("../Skeleton");
var config_1 = require("./config");
var Link = antd_1.Typography.Link, Paragraph = antd_1.Typography.Paragraph, Text = antd_1.Typography.Text, Title = antd_1.Typography.Title;
var components = {
    Text: Text,
    Title: Title,
    Paragraph: Paragraph,
    Link: Link,
};
var Typography = function (_a) {
    var _b = _a.component, component = _b === void 0 ? "Text" : _b, _c = _a.variant, variant = _c === void 0 ? "body-14" : _c, _d = _a.weight, weight = _d === void 0 ? "regular" : _d, children = _a.children, loading = _a.loading, _e = _a.loadingSize, loadingSize = _e === void 0 ? "default" : _e, props = __rest(_a, ["component", "variant", "weight", "children", "loading", "loadingSize"]);
    var Component = components[component];
    if (loading) {
        return (react_1.default.createElement(Skeleton_1.StyledSkeletonInput, { size: "default", width: config_1.loadingStylesMap[loadingSize].width, style: {
                height: config_1.variants[variant].fontSize,
                lineHeight: config_1.variants[variant].lineHeight,
            }, active: true }));
    }
    return (react_1.default.createElement(Component, __assign({}, props, { style: __assign(__assign(__assign({}, config_1.variants[variant]), config_1.fontWeights[weight]), props.style) }), children));
};
exports.Typography = Typography;
